
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'keyedCustomers',
            'keyedFieldOptions',
            'keyedPriceTypes',
            'keyedProducts',
			'keyedPosttypeItems'
        ])
    },
    methods : {
        getLocalOption(field, optionid) {
            let val = null;
            if(field.fieldoptions){
                val = _.find(field.fieldoptions, ['id', optionid]);
            }
            return val;
        },
        getValue(field, value, property = 'label', decorate = true) {
            let html = '';
            if (!property) property = 'label';
            if (value.value !== null && typeof value.value !== 'undefined'){
                if (field.type === 'select' || field.type === 'status' || field.type === 'posttype') {
                    if (value.format === 'array') {
                        for (let index = 0, valueObj; valueObj = value.value[index]; index++) {
                            if (field.internal_name === 'product' && this.keyedProducts[valueObj]) {
                                property = (property !== 'label' ? property : 'name');
                                html += this.keyedProducts[valueObj][property];
                            } else if (field.internal_name === 'customer' && this.keyedCustomers[valueObj]) {
                                property = (property !== 'label' ? property : 'name');
                                html += this.keyedCustomers[valueObj][property];
							} else if (field.type === 'posttype' && this.keyedPosttypeItems[valueObj]) {
                                property = (property !== 'label' ? property : 'name');
                                html += this.keyedPosttypeItems[valueObj][property];
                            } else if (this.keyedFieldOptions[valueObj] && this.keyedFieldOptions[valueObj].field_id === field.id) {
                                html += this.keyedFieldOptions[valueObj][property];
                            }else{
                                html += valueObj;
                            }
                            if (index + 1 !== value.value.length) {
                                html += ', ';
                            }
                        }
                    } else {
                        if (field.internal_name === 'product' && this.keyedProducts[value.value]) {
                            property = (property !== 'label' ? property : 'name');
                            html += this.keyedProducts[value.value][property];
                        } else if (field.internal_name === 'customer' && this.keyedCustomers[value.value]) {
                            property = (property !== 'label' ? property : 'name');
                            html += this.keyedCustomers[value.value][property];
						} else if (field.type === 'posttype' && this.keyedPosttypeItems[value.value]) {
                            property = (property !== 'label' ? property : 'name');
                            html += this.keyedPosttypeItems[value.value][property];
                        } else if (field.internal_name === 'price_type' && this.keyedPriceTypes[value.value]) {
                            property = (property !== 'label' ? property : 'name');
                            html += this.keyedPriceTypes[value.value][property];
                        } else if (this.keyedFieldOptions[value.value] && this.keyedFieldOptions[value.value].field_id === field.id) {
                            html += this.keyedFieldOptions[value.value][property];
                        } else if (this.getLocalOption(field, value.value)) {
                            html += this.getLocalOption(field, value.value)[property];
                        } else {
                            html += value.value;
                        }
                    }
                } else if (field.type === 'date') {
                    if(this.format){
                        html += moment(value.value).format(this.format);
                    }else{
                        html += this.$options.filters.moment(value.value);
                    }
                } else if (value.pricefield && decorate) {
                    html += this.$options.filters.price(value.value);
                } else if (value.format === 'object') {
                    html += (value.value.filename ? value.value.filename : (value.value.name ? value.value.name : ''));
                } else {
                    html += value.value;
                }
            }
            if (decorate && field.configuration.prefix)
                html = field.configuration.prefix + html;
            if (decorate && field.configuration.suffix)
                html += field.configuration.suffix;
                
            return html;
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('DD/MM/YYYY');
        },
        price: function (value) {
            if (value == null) return '';
            return '£' + value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
};
